import React, { useContext } from "react";
import { Table } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { FILE_BROWSER_ROUTES } from "../../../constants";
import { expandedRowPaginationUpdated, expandedRowSortUpdated, selectExpandedRowPagination, selectExpandedRowSort, } from "../../../store/malwareSlice";
import { ComponentList } from "../../../ui";
import { ComponentName, ComponentPriorityAndIssuesLink } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetSoftwareDependencyDetailsQuery } from "../../services/shared.api";
const DependencyReferences = ({ rowIndex, dependency, }) => {
    var _a;
    const dispatch = useReportDispatch();
    const { reportId } = useContext(ReportContext);
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, dependency.identity.uuid));
    const sortBy = useReportSelector((state) => selectExpandedRowSort(state, dependency.identity.uuid));
    const { data = { match_count: 0, components: [] }, isFetching, isLoading, isError, error, } = useGetSoftwareDependencyDetailsQuery({
        ui_id: reportId,
        ui_item_id: dependency.identity.uuid,
        sort: sortBy,
        pagination,
    });
    const handleSortChange = (newSort) => {
        dispatch(expandedRowSortUpdated({
            id: dependency.identity.uuid,
            sort: newSort,
        }));
    };
    return (React.createElement(ComponentList.Table, { itemId: "dependency-references", rowIndex: rowIndex, title: React.createElement(React.Fragment, null,
            "Components that depend on ",
            React.createElement("b", null, dependency.identity.product)), matchCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0, queryStatus: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }), totalCount: dependency.references_count, pagination: pagination, onPaginationChange: (newPagination) => dispatch(expandedRowPaginationUpdated({
            id: dependency.identity.uuid,
            pagination: newPagination,
        })), columns: ComponentList.columns({
            sortBy,
            rowIndex,
            onSortChange: handleSortChange,
        }) }, data === null || data === void 0 ? void 0 : data.components.map((component, index) => {
        var _a;
        return (React.createElement(Table.Row, { key: (_a = component.id) !== null && _a !== void 0 ? _a : component.path },
            React.createElement(Table.Cell, null,
                React.createElement(ComponentList.PriorityAndIssues, { component: component, id: index.toString(), badgeWrapper: (target, children) => (React.createElement(ComponentPriorityAndIssuesLink, { htmlId: index.toString(), componentId: component.id, componentPath: component.path, target: target }, children)) })),
            React.createElement(Table.Cell, null,
                React.createElement(ComponentName, { component: component, id: index.toString(), fileBrowserPage: FILE_BROWSER_ROUTES.INFO_ROUTE })),
            React.createElement(Table.Cell, null,
                React.createElement(ComponentList.Path, { path: component.path }))));
    })));
};
export default DependencyReferences;
//# sourceMappingURL=DependencyReferences.js.map